// HBO Associate Degree Studies
// University of Applied Sciences Associate Degree programs (2-year programs)

export const HBO_ASSOCIATE_DEGREE_STUDIES = {
  'Economisch en Bedrijf': {
    'Bedrijfskunde & Management': [
      'Bedrijfskunde',
      'Business Administration',
      'Management',
      'Technische Bedrijfskunde',
      'Technische Bedrijfskunde & IT',
      'International Business',
      'International Business Management',
      'Sustainability',
      'Ondernemerschap & Retail Management',
      'Ondernemen',
      'Business School Notenboom',
      'Bedrijfskunde en Agribusiness'
    ],
    'Finance & Accountancy': [
      'Accountancy',
      'Finance',
      'Finance & Control',
      'Financieel Management',
      'Sociaal Financiële Dienstverlening',
      'Payroll Services'
    ],
    'Marketing & Communicatie': [
      'Online Marketing',
      'Marketing Management',
      'Commerciële Economie',
      'Commerciële Economie & Ondernemerschap',
      'E-commerce',
      'Commercieel Management',
      'Communicatie',
      'Smart Media Production',
      'Online Contentcreator',
      'Crossmediale Communicatie',
      'Creative Media Professional',
      'Digitale Techniek & Media',
      'Media Design'
    ],
    'Hospitality, Horeca & Toerisme': [
      'Horeca Management',
      'Hotel Management',
      'International Hospitality Management',
      'Hotel & Event Management',
      'Tourism Management',
      'Internationaal Toeristisch Management',
      'Leisure & Event Management',
      'Leisure & Events Management'
    ],
    'Logistiek & Supply Chain': [
      'Logistics & Supply Chain Management',
      'Supply Chain Management',
      'Logistiek',
      'Logistiek Management'
    ],
    'Human Resources & Organisatie': [
      'Human Resource Management',
      'Officemanagement',
      'Facilitair Eventmanagement',
      'Facility Management'
    ],
    'Sales & Retail': [
      'Sales en Accountmanagement',
      'Ondernemerschap & Retail Management'
    ],
    'Food & Fashion Business': [
      'Food, Business & Innovation',
      'Fashion Business Professional'
    ]
  },
  'Onderwijs & Pedagogiek': {
    'Educatie & Didactiek': [
      'Educatief Professional Beroepsonderwijs',
      'Pedagogisch Educatief Professional',
      'Didactisch Educatief Professional'
    ],
    'Onderwijs & Ondersteuning': [
      'Onderwijsondersteuner Gezondheidszorg en Welzijn',
      'Onderwijsondersteuner Consumptieve Techniek I en II',
      'Onderwijsondersteuner Omgangskunde',
      'Onderwijsondersteuner Technisch Beroepsonderwijs',
      'Schrijftolk',
      'Kinderopvang'
    ]
  },
  'Design & Kunst': {
    'Design & Interieur': [
      'Design',
      'Interior Brand Identity',
      'Interieurvormgever'
    ],
    'Creatieve Kunsten': [
      'Arts & Crafts'
    ]
  },
  'Gezondheid & Zorg': {
    'Zorg & Welzijn': [
      'Management in de Zorg',
      'Zorg en Technologie',
      'Praktijkondersteuner Huisarts',
      'Ervaringsdeskundigheid in Zorg en Welzijn'
    ],
    'Zorg & Veiligheid': [
      'Zorg & Veiligheid'
    ]
  },
  'Exact & Informatica': {
    'Software & Development': [
      'Software Development',
      'Frontend Design & Development'
    ],
    'Cybersecurity & IT Management': [
      'Cybersecurity',
      'Cyber Safety & Security',
      'Information Security',
      'IT Service Management',
      'ICT Service Management'
    ],
    'ICT & Data': [
      'ICT & Telecommunicatie',
      'ICT-Engineer',
      'AD-ICT',
      'Informatica',
      'ICT Internet of Things',
      'Data Analytics',
      'ICT'
    ]
  },
  'Techniek & Bouw': {
    'Engineering & Mechatronica': [
      'Engineering',
      'Werktuigbouwkunde',
      'Mechatronica',
      'Mechatronica in de Smart Industry',
      'Embedded Systems Engineering'
    ],
    'Bouw & Constructie': [
      'Bouwkunde',
      'Bouwtechnisch Medewerker',
      'Integraal Bouwmanagement',
      'Civiele Techniek Projectvoorbereiding en Realisatie',
      'Built Environment',
      'Bouwmanagement'
    ],
    'Installatie & Onderhoud': [
      'Gebouwgebonden Installatietechniek',
      'Maintenance',
      'Smart Asset Maintenance'
    ],
    'Energietransitie & Duurzaamheid': [
      'Energietransitie Engineer'
    ],
    'Automatisering & Robotica': [
      'Industriële Automatisering en Robotica',
      'Industriële Automatisering'
    ],
    'Transport & Maritiem': [
      'Maritieme Techniek',
      'Automotive'
    ]
  },
  'Gedrag & Maatschappij': {
    'Sociaal Werk & Participatie': [
      'Sociaal Werk',
      'Participatie en Buurtontwikkeling',
      'Ervaringsdeskundigheid in Zorg en Welzijn'
    ],
    'Jeugd & Sport': [
      'Sport',
      'Jeugdwerker'
    ]
  },
  'Recht & Bestuur': [
    'Juridisch Medewerker',
    'Rechten'
  ],
  'Aarde & Milieu': {
    'Voedsel & Landbouw': [
      'Tuinbouwmanagement',
      'Dier- en Veehouderij',
      'Tuinbouw en Akkerbouw',
      'Melkveehouderij',
      'Voedingsmiddelentechnologie'
    ],
    'Natuur & Landschap': [
      'Tuin- en Landschapsinrichting',
      'Land- en Watermanagement',
      'Groene Leefomgeving',
      'Omgevingskunde'
    ],
    'Milieu & Educatie': [
      'Educatie en Kennismanagement Groene Sector'
    ],
    'Creatieve Groenvoorziening': [
      'Bloemsierkunst'
    ],
    'Culinary & Voeding': [
      'Culinary Professional'
    ]
  }
};

export default HBO_ASSOCIATE_DEGREE_STUDIES;